export enum PromoteJobTypesEnums {
  LITE = 'LITE',
  PLUS = 'PLUS',
  PRO = 'PRO',
  STANDARD = 'STANDARD',
  EMPTY = 'EMPTY',
}
